module.exports = __webpack_public_path__ + "img/holly_headshot.bba505cd.jpg";